(function () {
  'use strict';

  var eventsBound = false;
  var interactionsBound = false;
  var fetchTimer = null;

  function getWishlistPageUrl() {
    if (window.gebestWishlistConfig && window.gebestWishlistConfig.pageUrl) {
      return window.gebestWishlistConfig.pageUrl;
    }

    return '/pages/ulubione';
  }

  function isSwymListLink(link) {
    if (!link) return false;

    if (link.classList.contains('swym-storefront-layout-notification-action')) {
      return true;
    }

    var href = link.getAttribute('href') || '';
    return href.indexOf('#/swym-list') !== -1;
  }

  function rewriteWishlistLink(link) {
    if (!isSwymListLink(link)) return;

    if (link.tagName === 'A') {
      link.setAttribute('href', getWishlistPageUrl());
    }

    link.removeAttribute('data-swym-page');
  }

  function rewriteWishlistLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.swym-storefront-layout-notification-action, a[href="#/swym-list"], a[href*="#/swym-list"]').forEach(function (link) {
      rewriteWishlistLink(link);
    });
  }

  function bindWishlistLinkInterceptor() {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target.closest('.swym-storefront-layout-notification-action, a[href="#/swym-list"], a[href*="#/swym-list"]');
        if (!target) return;

        event.preventDefault();
        event.stopPropagation();
        window.location.href = getWishlistPageUrl();
      },
      true
    );
  }

  function observeSwymNotifications() {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          rewriteWishlistLinks(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function getCountElements() {
    return document.querySelectorAll('[data-gebest-wishlist-count]');
  }

  function getBadgeElements() {
    return document.querySelectorAll('[data-gebest-wishlist-badge]');
  }

  function updateWishlistCount(count) {
    var safeCount = typeof count === 'number' && count > 0 ? count : 0;

    getCountElements().forEach(function (el) {
      el.textContent = String(safeCount);
    });

    getBadgeElements().forEach(function (el) {
      el.textContent = String(safeCount);
      el.hidden = safeCount <= 0;
    });

    document.dispatchEvent(
      new CustomEvent('gebest:wishlist:count-updated', {
        detail: { count: safeCount }
      })
    );
  }

  function isWishlistButton(node) {
    if (!node || !node.closest) return false;
    return !!node.closest('.gebest-wishlist-button, .swym-add-to-wishlist-view-product');
  }

  function scheduleFetchWishlistCount(delay) {
    if (fetchTimer) {
      window.clearTimeout(fetchTimer);
    }

    fetchTimer = window.setTimeout(function () {
      fetchTimer = null;
      fetchWishlistCount(window._swat);
    }, typeof delay === 'number' ? delay : 200);
  }

  function fetchWishlistCount(swat) {
    if (!swat) {
      updateWishlistCount(0);
      return;
    }

    function applyCount(products) {
      updateWishlistCount(Array.isArray(products) ? products.length : 0);
    }

    if (typeof swat.fetchLists === 'function') {
      swat.fetchLists({
        callbackFn: function (lists) {
          var defaultList = lists && lists.length ? lists[0] : null;
          applyCount(defaultList ? defaultList.listcontents || [] : []);
        },
        errorFn: function () {
          if (typeof swat.fetch === 'function') {
            swat.fetch(applyCount);
          } else {
            updateWishlistCount(0);
          }
        }
      });
      return;
    }

    if (typeof swat.fetch === 'function') {
      swat.fetch(applyCount);
      return;
    }

    updateWishlistCount(0);
  }

  function bindWishlistEvents(swat) {
    if (!swat || eventsBound || !swat.evtLayer || typeof swat.evtLayer.addEventListener !== 'function') {
      return false;
    }

    eventsBound = true;

    swat.evtLayer.addEventListener('sw:addedtowishlist', function () {
      scheduleFetchWishlistCount();
    });

    swat.evtLayer.addEventListener('sw:removedfromwishlist', function () {
      scheduleFetchWishlistCount();
    });

    swat.evtLayer.addEventListener('sw:customerInfoRefreshed', function () {
      scheduleFetchWishlistCount();
    });

    return true;
  }

  function bindWishlistInteractions() {
    if (interactionsBound) return;
    interactionsBound = true;

    document.addEventListener(
      'click',
      function (event) {
        if (!isWishlistButton(event.target)) return;
        scheduleFetchWishlistCount(450);
      },
      true
    );

    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') continue;
        if (!isWishlistButton(mutation.target)) continue;
        scheduleFetchWishlistCount();
        return;
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  function initWishlistHeader(swat) {
    if (!swat) return;

    bindWishlistInteractions();

    if (!bindWishlistEvents(swat)) {
      var attempts = 0;
      var retryTimer = window.setInterval(function () {
        attempts += 1;
        bindWishlistEvents(swat);
        if (eventsBound || attempts >= 24) {
          window.clearInterval(retryTimer);
        }
      }, 250);
    }

    scheduleFetchWishlistCount(0);
  }

  document.addEventListener('gebest:wishlist:updated', function () {
    scheduleFetchWishlistCount();
  });

  window.gebestUpdateWishlistCount = function () {
    scheduleFetchWishlistCount(0);
  };

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initWishlistHeader);

  if (window._swat) {
    initWishlistHeader(window._swat);
  }

  function bootWishlistLinks() {
    rewriteWishlistLinks(document);
    bindWishlistLinkInterceptor();
    observeSwymNotifications();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWishlistLinks);
  } else {
    bootWishlistLinks();
  }
})();
